import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import FormControl from 'react-bootstrap/FormControl';

export default class SecurityPage extends Component {
    constructor() {
        super();

        // initialize state variables
        this.state = {
            patientBirthMonth: -1,
            patientBirthDay: -1,
            patientBirthYear: null,
            phoneDigits: null
        }

        // bind functions for accessing state
        this.handleFormControlChange = this.handleFormControlChange.bind(this);
    }

    // fired when form control changes
    // note: control must have id property and correspondig state value for this to work
    handleFormControlChange(event) {
        this.setState({ [event.target.id]: event.target.value });
    }

    render() {
        return(
            <div className="SecurityColumn">
                <Form>
                    <Form.Row>
                        <Form.Label>Date of Birth:</Form.Label>
                    </Form.Row>
                    <Form.Row>
                        <div className="SecurityCondition">
                            <FormControl id="patientBirthMonth" as="select" className="BirthMonth" onChange={this.handleFormControlChange}
                            value={this.state.patientBirthMonth}>
                                <option disabled value={-1}></option>
                                <option value="1">Jan</option>
                                <option value="2">Feb</option>
                                <option value="3">Mar</option>
                                <option value="4">Apr</option>
                                <option value="5">May</option>
                                <option value="6">Jun</option>
                                <option value="7">Jul</option>
                                <option value="8">Aug</option>
                                <option value="9">Sept</option>
                                <option value="10">Oct</option>
                                <option value="11">Nov</option>
                                <option value="12">Dec</option>
                            </FormControl>
                            &nbsp;/&nbsp;
                            <FormControl id="patientBirthDay" as="select" className="BirthDay" onChange={this.handleFormControlChange}
                            value={this.state.patientBirthDay}>
                                <option disabled value={-1}></option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                                <option>6</option>
                                <option>7</option>
                                <option>8</option>
                                <option>9</option>
                                <option>10</option>
                                <option>11</option>
                                <option>12</option>
                                <option>13</option>
                                <option>14</option>
                                <option>15</option>
                                <option>16</option>
                                <option>17</option>
                                <option>18</option>
                                <option>19</option>
                                <option>20</option>
                                <option>21</option>
                                <option>22</option>
                                <option>23</option>
                                <option>24</option>
                                <option>25</option>
                                <option>26</option>
                                <option>27</option>
                                <option>28</option>
                                <option>29</option>
                                <option>30</option>
                                <option>31</option>
                            </FormControl>
                            &nbsp;/&nbsp;
                            <FormControl id="patientBirthYear" className="PhoneDigits" placeholder="YYYY" maxLength="4"
                                onChange={this.handleFormControlChange} value={this.state.patientBirthYear}></FormControl>
                        </div>
                    </Form.Row>
                    <Form.Row>
                        <Form.Label>Phone Number:</Form.Label>
                    </Form.Row>
                    <Form.Row>
                        <div className="SecurityCondition">
                            {this.props.phoneDigits}<FormControl id="phoneDigits" className="PhoneDigits" placeholder="XXXX" maxLength={4}
                                        onChange={this.handleFormControlChange} value={this.state.phoneDigits}>
                                    </FormControl>
                        </div>
                    </Form.Row>
                </Form>                 
            </div>
        );
    }
}